class ReducerRegistry {
  #reducers = []

  #onChange = () => undefined

  add(name, reducer) {
    this.#reducers[name] = reducer

    this.#onChange(this.list())
  }

  list() {
    return { ...this.#reducers }
  }

  onChange(onChange) {
    this.#onChange = onChange
  }
}

export const reducerRegistry = new ReducerRegistry()
